import React, { useState } from 'react';
import { ArrowLeft,Eye } from 'lucide-react';
import CustomDataGrid from '../../../components/common/CustomDataGrid/CustomDataGrid';
import CustomSearch from '../../../components/common/CustomSearch';
import { useNavigate } from 'react-router-dom';
import CustomButton from '../../../components/common/CustomButton/CustomButton';
import ServerPaginationDataGridWithReactQuery from '../../../components/common/CustomDataGrid/ServerPaginationDataGridWithReactQuery';
import { remenurationCompanyFinanceUrl } from '../../../utils/urls';
const initialRows = [
  {
    id: 1,
    company: 'HDFC',
    logo: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=100&h=100&fit=crop',
    convertedLeads: 12,
    totalEarnings: '₹2,20,000',
    pendingEarnings: '₹40,000',
    lastPaymentDate: '12 Jan 2025',
  },
  {
    id: 2,
    company: 'ICICI',
    logo: 'https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?w=100&h=100&fit=crop',
    convertedLeads: 12,
    totalEarnings: '₹2,20,000',
    pendingEarnings: '₹40,000',
    lastPaymentDate: '12 Jan 2025',
  },
  {
    id: 3,
    company: 'MAX',
    logo: 'https://images.unsplash.com/photo-1600880292149-74fb3e87b443?w=100&h=100&fit=crop',
    convertedLeads: 12,
    totalEarnings: '₹2,20,000',
    pendingEarnings: '₹40,000',
    lastPaymentDate: '12 Jan 2025',
  },
  {
    id: 4,
    company: 'Aditya Birla',
    logo: 'https://images.unsplash.com/photo-1600880292054-4ac4444d1497?w=100&h=100&fit=crop',
    convertedLeads: 12,
    totalEarnings: '₹2,20,000',
    pendingEarnings: '₹40,000',
    lastPaymentDate: '12 Jan 2025',
  },
];
const FinancialPartner = () => {
  const navigate = useNavigate();
  // const columns = [
  //   {
  //     field: 'company_name',
  //     headerName: 'Company Name',
  //     width: '250px',
  //     renderCell: (row) => (
  //       <div className="flex items-center gap-3">
  //         <img src={row.logo} alt={row.company} className="w-10 h-10 rounded" />
  //         <span>{row.company}</span>
  //       </div>
  //     ),
  //   },
  //   {
  //     field: 'convertedLeads',
  //     headerName: 'Converted Leads',
  //     width: '200px',
  //   },
  //   {
  //     field: 'totalEarnings',
  //     headerName: 'Total Earnings',
  //     width: '200px',
  //   },
  //   {
  //     field: 'pendingEarnings',
  //     headerName: 'Pending Earnings',
  //     width: '200px',
  //   },
  //   {
  //     field: 'lastPaymentDate',
  //     headerName: 'Last Payment Date',
  //     width: '200px',
  //   },
  //   {
  //     field: 'action',
  //     headerName: 'Action',
  //     width: '150px',
  //     renderCell: () => (
  //       <CustomButton
  //           label="View"
  //           variant="text"
  //           startIcon={<Eye className="w-4 h-4" />}
  //           size="sm"
  //           onClick={() => {navigate("/companydetail") }}
  //         />
  //     ),
  //   },
  // ];
  const columns = [
    {
      field: "company_name",
      headerName: "Company Name",
      width: "200px",
      renderCell: (row) => (
        
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-md overflow-hidden flex items-center justify-center bg-gray-100">
            <img src={row?.logo_url || "/placeholder.svg"} alt={row?.company_name} className="w-8 h-8 object-contain" />
          </div>
          <span>{row?.company_name}</span>
        </div>
      )
    },
    {
      field: "converted_lead_count",
      headerName: "Converted Leads",
      width: "200px"
    },
    {
      field: "total_earning_amount",
      headerName: "Total Earnings",
      width: "200px"
    }
  ]
  const [searchTerm, setSearchTerm] = useState('');
  const [search, setSearch] = useState('');
  const [rows, setRows] = useState(initialRows);
  const handleSearch = (term) => {
    setSearchTerm(term);
    const filteredRows = initialRows.filter(row =>
      row.company.toLowerCase().includes(term.toLowerCase())
    );
    setRows(filteredRows);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 flex items-center gap-4">
          <button className="p-2 hover:bg-gray-100  border rounded-md" onClick={() => { navigate("/remuneration") }}>
            <ArrowLeft className="w-6 h-6 text-gray-600" />
          </button>
          <h1 className="text-2xl font-semibold text-blue-900">Financial Partners</h1>
        </div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="p-6 border-b border-gray-200">
            <div className="flex justify-between items-center">
              <div className="w-80">
                <CustomSearch
                  placeholder="Search partners..."
                  onChange={(e) => setSearch(e)}
                  className="w-full"
                />
              </div>
              <div className="flex items-center gap-3">
                <select className="px-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
                  <option>Sort By</option>
                  <option>Highest Earnings</option>
                  <option>Lowest Earnings</option>
                  <option>Most Leads</option>
                  <option>Recent Payments</option>
                </select>
              </div>
            </div>
          </div>
          <ServerPaginationDataGridWithReactQuery
                                      url={remenurationCompanyFinanceUrl}
                                      requestParameter={{}}
                                      height={'50rem'}
                                      search={search}
                                      limit='5'
                                      columns={columns}
                                      isServerPagination={true}
                                      dataMapper={(list) => list}
                                    />
          {/* <CustomDataGrid
            columns={columns}
            rows={rows}
            keyId="id"
            perPageSize={10}
            showPagination={true}
          /> */}
        </div>
      </div>
    </div>
  );
}

export default FinancialPartner

